<template>
  <td
    class="border-b border-slate-200 px-2 py-2 text-left transition-all group-hover:bg-blue-100/20 dark:border-slate-600 dark:group-hover:bg-blue-400/10"
  >
    <slot />
  </td>
</template>

<script setup lang="ts"></script>
